import { h } from 'preact';
import { DAI_AD_TYPE } from '../../../../ad/dai/types';
import { useNewStore, usePlayerContext, useStyles } from '../../../common/hooks';
import { useVisibleClass } from '../../../common/utils/tools';
import { withBreakPoints } from '../../hoc';
import { ExpControl, PlaybackControl, Timeline } from '../controls';
import { FLEX_50_VERTICAL_STYLE } from './styles';

const styles = {
  base: {
    default: {
      ...FLEX_50_VERTICAL_STYLE,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      gap: 8
    },
    'largeTv+extraLargeTv': {
      height: 'unset',
      flex: 'unset',
      flexDirection: 'column-reverse',
      gap: '24px'
    },
    'extraSmall+small': {
      gap: 6
    }
  },
  controls: {
    default: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      transition: 'opacity .2s ease-in-out, visibility .2s'
    },
    'largeTv+extraLargeTv': {
      justifyContent: 'start',
      gap: '76px',
      height: '90px',
      alignItems: 'center'
    }
  },
  timeline: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    width: '100%'
  },
  hidden: {
    display: 'none'
  }
};

function SectionBottom({
  hidden
}) {
  const setStyles = useStyles();
  const player = usePlayerContext();
  const { hoverTimeline, isSeeking, UIVisible, canInteract, waitStart } = useNewStore('ui', player);
  const { isDAI, isLive, timeshifting: { type: timeshifting, startOverTimeshifting: isShifting } } = useNewStore('media', player);
  const { showCountdown, adType, isAd } = useNewStore('ad', player);
  const timelineStyles = setStyles({
    default: {
      ...styles.timeline,
      display: (isLive || isAd || showCountdown) ? 'none' : 'flex',
      ...(timeshifting ? {
        display: 'flex'
      } : {})
    },
    'small+extraSmall': { gap: 6 },
    'largeTv+extraLargeTv': { marginTop: '24px' }
  });

  const controlsVisibilityClass = useVisibleClass(!(isSeeking || hoverTimeline));

  if (waitStart || !canInteract || !UIVisible || hidden) return null;
  return (
    <div
      className="magneto--section-bottom"
      style={setStyles(styles.base)}
    >
      <div
        className={`${controlsVisibilityClass}`}
        style={setStyles(styles.controls)}
      >
        <PlaybackControl />
        <ExpControl />
      </div>

      <div style={timelineStyles}>
        {
          (
            (!isLive && !isAd && !showCountdown)
            || (timeshifting && !isAd && !showCountdown)
            || (timeshifting && isDAI && isAd && adType === DAI_AD_TYPE)
            || isShifting
          ) && <Timeline />
        }
      </div>
    </div>
  );
}

export default withBreakPoints(SectionBottom);
